import { trackEvent } from '@patrianna/analytics'
import { nextTick } from '@patrianna/shared-utils'
import { setCookie } from '@patrianna/shared-utils/cookie'

import BannerTile from 'components/BannerTile'
import ROUTES from 'config/routes.json'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'

function SCbanner() {
  const bannerUrl = generateImageUrl('banners/sc-banner/source.png', ImagesDirectory.BANNERS)

  const onClickHandler = () => {
    nextTick().then(() => {
      trackEvent('clicked_on_banner', { category: 'sc-banner' })
      setCookie('IS_USER_OPENED_SC_RULES', '1')
    })
  }

  return (
    <BannerTile
      url={`${ROUTES.SWEEPSTAKE_RULES}#how-to-collect-sweepstake-coins`}
      onClick={onClickHandler}
      src={bannerUrl}
      alt='sc banner'
      dataTest='sc-banner'
    />
  )
}

export default SCbanner
